import React from "react"
import CookieConsent from 'react-cookie-consent';

import Header from "../Header"
import Footer from "../Footer"
import Gotop from "../Gotop"

import "./layout.scss"

const Layout = ({ children }) => {
  return (
    <div className="page-container">
      <Header />
      <main>
        {children}
      </main>
      <Footer />

      <Gotop />

      <CookieConsent
        buttonText="Okej!"
        style={{ background: "rgba(255, 255, 255, 0.9)", color: "#1C222B", fontSize: "16px", margin: "5px", border: "solid 1px #d0d7de", width: "calc(100% - 10px)", borderRadius: "5px" }}
        buttonStyle={{ color: "#fff", background: "#39b54a", boxShadow: "0 2px 0 #1f782b", fontSize: "16px", fontWeight: "700", borderRadius: "5px", padding: "10px 20px" }}>
        För att kunna erbjuda en så bra upplevelse som möjligt använder vi cookies.
      </CookieConsent>
    </div>
  )
}

export default Layout